import { createAsyncThunk } from "@reduxjs/toolkit";

import AuthController from "../Controllers/AuthController";

import HttpsClient from "../../../Services/HttpsClient";
import ApiHelper from "../../../Services/ApiHelper";

const httpsClient = new HttpsClient();
const apiHelper = new ApiHelper(httpsClient);

const authController = new AuthController(apiHelper);

// authController returns the standard envelope { statusCode, data, message }.
// Success (HTTP 2xx) -> statusCode === 1 with the user in `data`.
// Failure (HTTP 4xx/5xx) -> HttpClient returns the same envelope with statusCode !== 1;
// reject with the backend message so the UI can surface it.
export const login = createAsyncThunk("user/login", async (credentials, { rejectWithValue }) => {
  const response = await authController.login(credentials);

  if (!response || response.statusCode !== 1) {
    return rejectWithValue(response?.message || "Giriş başarısız");
  }

  return response.data;
});

export const googleOAuth = createAsyncThunk("user/googleOAuth", async (credentials, { rejectWithValue }) => {
  const response = await authController.googleOAuth(credentials);

  if (!response || response.statusCode !== 1) {
    return rejectWithValue(response?.message || "Giriş başarısız");
  }

  return response.data;
});
